import {connect} from "react-redux";
import SearchResult from "../../_data/models/SearchResult";
import SearchResultComponent from "../components/SearchResultComponent";
import {dataByResourceNameSelector, shopByIdSelector, userByIdSelector} from "../../_data/selectors";
import * as pluralize from "pluralize";
import {apiModelNameToClientModelName} from "../../_helpers/utils";
import {ResourceType} from "../../_helpers/data";
import {ShopsRoutes, SpecialsRoutes, StylesRoutes, UsersRoutes} from "../../routes";
import {push} from "react-router-redux";
import Booth from "../../_data/models/Booth";
import Special from "../../_data/models/Special";
import Style from "../../_data/models/Style";
import {plainToClass} from "class-transformer";
import {initializeShopProfile} from "../../shop/middlewares";
import Shop from "../../_data/models/Shop";

interface Props {
    result: SearchResult;
    forTrending?: boolean;
}

const mapStateToProps = (state, props: Props) => {
    const {result} = props;
    const data = dataByResourceNameSelector(state, pluralize(apiModelNameToClientModelName(result.type)).toLowerCase());
    const model = data.get(result.modelId);
    const dependencies = {};

    if (model instanceof Booth)
        dependencies['shop'] = shopByIdSelector(state, (model as Booth).shopId);
    if (model instanceof Special)
        dependencies['user'] = userByIdSelector(state, (model as Special).userId);
    if (model instanceof Style)
        dependencies['user'] = userByIdSelector(state, (model as Style).userId);
    if (model instanceof Shop)
        dependencies['user'] = userByIdSelector(state, (model as Shop).userId);

    return {
        result: result,
        model: model,
        dependencies: dependencies
    };
};

const mapDispatchToProps = (dispatch, props: Props) => {
    const {result} = props;

    return {
        viewItem: () => {
            switch (apiModelNameToClientModelName(result.type).toLowerCase()) {
                case ResourceType.user:
                    return dispatch(push(UsersRoutes.show(result.modelId)));
                case ResourceType.shop:
                    dispatch(initializeShopProfile(result.modelId));
                    return dispatch(push(ShopsRoutes.view(result.modelId)));
                case ResourceType.booth:
                    let booth = plainToClass(Booth, result.entityProperties);
                    dispatch(initializeShopProfile(booth.shopId));
                    return dispatch(push(ShopsRoutes.viewBooth(booth.shopId, booth.id)));
                case ResourceType.style:
                    let s = result.entityProperties as Style;
                    return dispatch(push(StylesRoutes.showStyle(s.user.name, s.id)));
                case ResourceType.special:
                    return dispatch(push(SpecialsRoutes.show(result.modelId)));
            }
        }
    }
};

const SearchResultContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(SearchResultComponent);
export default SearchResultContainer;


// WEBPACK FOOTER //
// ./app/client/search/containers/SearchResultContainer.tsx